import { mapState } from 'vuex';
import MUTATIONTYPES from '../../store/mutation-types';
import config from '../config';
import {
  redirectToLogout,
  needLogin,
  needRole,
  needAdmin,
} from '../utils/error-handler';

export default {
  computed: {
    ...mapState({
      user: 'user',
      needLogin: 'needLogin',
      needRole: 'needRole',
    }),
  },
  methods: {
    handleGetUserInfo () {
      // 初始化用户数据
      this.$showLoading('拉取用户数据中，请稍候...');
      let promise = this.$store.dispatch({
        type: MUTATIONTYPES.GET_USER_INFO,
      });

      promise
        .then(() => {
          // 登陆成功后将user写入ls
          const lsUser = config.lsUser;
          try {
            const user = JSON.stringify(this.$store.state.user);
            window.localStorage.setItem(lsUser, user);
          }
          catch (err) {
            console.warn('JSON stringify error');
          }

          // 如果处于站点，存储顶部目录预留给资源中心使用
          if (config.hostType === 'open') {
            try {
              window.localStorage.setItem(config.lsEntryList,
                JSON.stringify(this.$store.state.entryList));
            }
            catch (err) {
              console.warn('JSON stringify error');
            }
          }
          /**
           * 非超管默认跳分系统管理
           */
          if (config.hostType === 'open-admin' &&
            this.$route.fullPath === '/overview' &&
            this.user.roleId !== '1_1_sys_super_admin') {
            // this.$router.replace('/system/overview');
            window.location.href = '/system/overview';
          }
          // 如果该模块所需要的role不为空
          else if (this.needRole !== '') {
            if (this.user.roleId === '' ||
              this.needRole.indexOf(this.user.roleId) === -1) {
              // 用户的最高级roleId为空（不在roleMap里面）
              // 用户的最高级roleId不符合预期
              needAdmin({
                callback () {
                  window.location.href = config.homePage;
                },
              });
              return false;
            }
          }
        })
        .catch(err => {
          console.error(err);
          if (err.message) {
            if (err.message.indexOf('401') !== -1) {
              if (this.needLogin) {
                needLogin();
              }
            }

            if (err.message === 'noAuth') {
              needRole({
                errcode: 'fe.-500',
                errmsg: '权限不符合预期',
                callback () {
                  redirectToLogout();
                },
              });
            }
          }
        });
    },
  },
};
